import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';
import WP from 'WP';
import Container from 'partials/Container';
import Flex from 'partials/Flex';
import { Button } from 'partials/formElements';
import { h1Styles, h1SmallStyles } from 'partials/typography';
import PointerDown from 'images/PointerDown';
import EditBooking from './EditBooking';

import {
    setBookingGoal,
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setBookingReference,
    setEditedBookingTimeSlotBackup,
    setBookingMeetingType
} from 'store';

class BookMeeting extends Component {
  
    render() {
        const { goal, sideBar, setBookingGoal, setBookingVisibility, setBookingProgressCollapsedValue, setCartCollapsedValue, setBookingReference, setEditedBookingTimeSlotBackup, setBookingMeetingType, data } = this.props;

        const goals = WP.options.carear_goals || [];

        if(data && data.layout_type === 'edit') return <EditBooking data={data} />

        return (
            <Wrapper sideBar={sideBar}>
                <Container flex direction="column">
                    <GoalSelector sideBar={sideBar}>
                        Jeg vil bli
                        <div>
                            {goal}. 
                            <PointerDown color="#fff"/>
                            <select onChange={e => setBookingGoal(e.target.value)} >
                                {goals.map(({ goal }) => <option value={goal} key={goal} >{goal}</option>)}
                            </select>
                        </div>
                    </GoalSelector>
                    <Flex justify="center">
                        <Button outline white onClick={() => {
                            setBookingMeetingType('Lånekassen');
                            setBookingVisibility(true);
                            setBookingProgressCollapsedValue(false);
                            setCartCollapsedValue(true);
                            setBookingReference(null);
                            setEditedBookingTimeSlotBackup(null);
                        }}>La oss fortelle deg hvordan.</Button>
                    </Flex>
                </Container>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    goal: state.bookMeeting.goal,
});

const actions = {
    setBookingGoal,
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setBookingReference,
    setEditedBookingTimeSlotBackup,
    setBookingMeetingType
}

export default connect(mapStateToProps, actions)(BookMeeting);


const Wrapper = styled.section`
    background: ${css.colors.darkBlue};
    padding: ${props => props.sidebar ? 50 : 80}px 0;

    @media(max-width: 767px) {
        padding: 50px 0;
    }

    button {
        margin-top: 40px;
        transition: all .2s ease-in-out;
        overflow: hidden;
    }
`

const GoalSelector = styled.div`
    color: #4CAAFF;

    ${props => props.sideBar ? 
        h1SmallStyles+ ` ` :  
        h1Styles+ ``
    }
    
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    > div {
        margin-left: 20px;
        position:relative;
        color:#fff;
        display: flex;
        align-items: center;
        select {
            appearance: none;
            font-size:20px;
            outline: none;
            border:none;
            color: ${css.colors.main};
            opacity:0;
            position:absolute;
            width:100%;
            height:100%;
            top:0;
            left:0;
            cursor:pointer;
        }
        svg {
            margin-left:20px;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/BookMeeting/BookMeeting.js